import React, {Component} from 'react';
import {
  Row,
  Col,
  Grid,
  Panel,
  Table,
  PanelBody,
  PanelHeader,
  PanelContainer,
  Icon,
  PanelFooter,
} from '@sketchpixy/rubix';

import {getRoleGroups} from '../../../api/api';
import {Link, withRouter} from 'react-router';
import moment from 'moment';
import {routeUrl} from '../../routeUrl';
import {checkRole} from '../../../util/RoleChecker';
import RoleType from '../../RoleGroup/Roles/RoleType';

@withRouter
export default class RoleGroups extends Component {
  constructor(props) {
    super(props);

    this.state = {
      roleGroups: [],
    };
  }

  componentDidMount() {
    const requiredRoles = [
      RoleType.PERMISSION_GROUP,
      RoleType.PERMISSION_GROUP_READ_ONLY,
    ];

    checkRole(requiredRoles, this.props.router);

    let roles = JSON.parse(localStorage.getItem('roles'));
    let roleRegion = null;

    requiredRoles.forEach(requiredRoleType => {
      roles.forEach(role => {
        if (role.roleType && RoleType.enumValueOf(role.roleType.name) === requiredRoleType) {
          roleRegion = role.region;
        }
      });
    });

    getRoleGroups((err, result) => {
      this.setState({roleGroups: result});
    });
  }

  // 추후 새로운 기획 내용으로 구현요
  // deletePermission(event) {
  //   let p = $(event.currentTarget).parent().parent();
  //   let id = $(p).attr('id');
  //
  //   vex.dialog.confirm({
  //     message: 'Are you sure to delete?',
  //     callback: (value) => {
  //       if (value) {
  //         //delete api
  //         deletePermission(id, (err, result) => {
  //           if (err) {
  //             Messenger().post({
  //               type: 'error',
  //               message: 'Error while deleting! \n error => ' + err.message,
  //               showCloseButton: true,
  //             });
  //           } else {
  //             Messenger().post({
  //               type: 'success',
  //               message: 'permission deleted successfully.',
  //               showCloseButton: true,
  //             });
  //
  //             getRoleGroups((err, result) => {
  //               this.setState({roleGroups: result});
  //             });
  //           }
  //         });
  //       } else {
  //         vex.dialog.alert('Delete canceled.');
  //       }
  //     },
  //   });
  // }

  render() {
    return (
        <PanelContainer controls={false}>
          <Panel>
            <PanelHeader className='bg-pinkishred fg-white'>
              <Grid>
                <Row>
                  <Col xs={12}>
                    <h3><Icon bundle='stroke-gap-icons' glyph='Puzzle' />&nbsp; User roles</h3>
                  </Col>
                </Row>
              </Grid>
            </PanelHeader>
            <PanelBody>
              <Grid>
                <Row>
                  <Col xs={12}>
                    <Link to={routeUrl.adminRoleGroupCreate}>
                      <div style={{'float': 'right', fontSize: '18px'}}>
                        <Icon bundle='fontello' glyph='plus-squared-alt' />
                        &nbsp;Create new
                      </div>
                    </Link>
                    <Table id="permissionTable" style={{tableLayout: 'fixed'}}>
                      <thead>
                      <tr>
                        <th>Name</th>
                        <th>Key</th>
                        <th>Description</th>
                        <th>Created</th>
                        <th style={{width: '5%'}}>&nbsp;</th>
                      </tr>
                      </thead>
                      <tbody>
                      {
                        this.state.roleGroups.map(roleGroup => (
                            <tr id={roleGroup.roleGroupId} key={roleGroup.roleGroupId}>
                              <td style={{textOverflow: 'ellipsis', overflow: 'hidden', whiteSpace: 'nowrap'}}>
                                {roleGroup.roleGroupName}
                              </td>
                              <td style={{textOverflow: 'ellipsis', overflow: 'hidden', whiteSpace: 'nowrap'}}>
                              {roleGroup.roleGroupKey}
                            </td>
                              <td style={{textOverflow: 'ellipsis', overflow: 'hidden', whiteSpace: 'nowrap'}}>
                                {roleGroup.roleGroupDescription}
                              </td>
                              <td>{moment(roleGroup.createdTime).format('llll')}</td>
                              <td>
                                <Link to={`${routeUrl.adminRoleGroupEdit}/${roleGroup.roleGroupId}`}>
                                  <Icon bundle='fontello' glyph='pencil icon-2x' />
                                  &nbsp;
                                </Link>
                              </td>
                              {/*<td>*/}
                              {/*<Link onClick={this.deletePermission} style={{cursor: 'pointer'}}>*/}
                              {/*<Icon bundle='fontello' glyph='trash-2 icon-2x' />*/}
                              {/*&nbsp;*/}
                              {/*</Link>*/}
                              {/*</td>*/}
                            </tr>
                        ))
                      }
                      </tbody>
                    </Table>
                  </Col>
                </Row>
              </Grid>
            </PanelBody>
            <PanelFooter>
              <Grid>
                <Row>
                  <Col xs={12} className='fg-white' style={{marginBottom: '20px'}} />
                </Row>
              </Grid>
            </PanelFooter>
          </Panel>
        </PanelContainer>
    );
  }
}



// WEBPACK FOOTER //
// ./src/routes/permission/RoleGroups/RoleGroups.js